import React from 'react';

export const IconFilePdf: React.FC = () => {
    return (
        <svg width='41' height='41' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M25.97 5.97a3.3 3.3 0 0 0-2.35-.98H11.66a3.34 3.34 0 0 0-3.34 3.33v23.35c0 1.84 1.5 3.33 3.34 3.33h16.67a3.34 3.34 0 0 0 3.34-3.33V13.04c0-.89-.36-1.73-.98-2.36l-4.72-4.71Z'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinejoin='round'
            />
            <path
                d='M17.97 19.64c-.04.05-.12.05-.17 0a.14.14 0 0 1 0-.17c.05-.04.13-.04.17 0 .05.05.05.12 0 .17Z'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinejoin='round'
            />
            <path
                d='M25.83 20.44a6.2 6.2 0 0 0-7.06 7.06'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinejoin='round'
                strokeLinecap='round'
            />
            <rect
                x='14.16'
                y='15.83'
                rx='3.5'
                width='11.67'
                height='11.67'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinejoin='round'
            />
        </svg>
    );
};
